.productListContainer {
  width: 90%;
  max-width: 1200px;
  margin: auto;
  background: #fffdf7;
  padding: 30px;
  border-radius: 20px;
  corner-shape: superellipse(1.18);
  display: flex;
  flex-direction: column;
  gap: 30px;
}

.productListSelectContainer {
  display: flex;
  gap: 2vw;
  flex-wrap: wrap;
  justify-content: center;
}

.productItemContainer {
  display: flex;
  flex-direction: column;
  gap: 15px;
  cursor: pointer;
  margin-bottom: 10px;
  opacity: 0;
}

/* .productItemContainer:hover {
  .imageContainer > .productImage {
    opacity: 0.65;
    border: 2px solid #8f8f8f;
  }
  .imageButton {
    display: block;
    z-index: 9999;
  }
} */

.productItemContainer:not(.unavailable):hover .imageContainer > .productImage {
  opacity: 0.65;
  border: 2px solid #8f8f8f;
}

/* only show the button when NOT .unavailable */
.productItemContainer:not(.unavailable):hover .imageButton {
  display: block;
  z-index: 9999;
}

.imageContainer {
  display: inline-block;
  position: relative;
}

.productImage {
  width: auto;
  height: 200px;
  border: 2px solid #b4b4b4;
  border-radius: 26px;
  corner-shape: superellipse(1.18);
  object-fit: cover;
  opacity: 100%;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  transition: 0.3s;
}

.imageButton {
  display: none;
  position: absolute;
  transform: translate(-50%, -50%);
  top: 50%;
  left: 50%;
  animation: fadeInOut 0.3s ease-in-out;
}

.productTypeTitle {
  display: flex;
  justify-content: center;
  font-size: 18px;
  font-weight: 300;
  color: #505050;
}

.nameLink {
  text-decoration: none;
  color: inherit;
  cursor: pointer;
}

.name {
  font-size: 1.2rem;
  font-weight: 300;
  margin: 0;
  color: #505050;
}

/* not available product types */
.blurredImage {
  opacity: 0.55;
  transition: filter 0.3s ease;
}

.comingSoonOverlay {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 0.5em 1em;
  background-color: #888888bd;
  color: white;
  font-weight: 400;
  border-radius: 20px;
  pointer-events: none;
  z-index: 10;
}

.disabledName {
  color: #999;
  cursor: default;
}

@keyframes fadeInOut {
  0% {
    opacity: 0;
    display: none;
  }

  50% {
    opacity: 0.5;
    display: block;
  }

  100% {
    opacity: 1;
    display: block;
  }
}

@media (max-width: 900px) {
  .productListContainer {
    padding: 0;
  }
}
